<template>
  <!-- <div> -->
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn
          @click.stop="dialog = true"
          large
          outlined
          text
          rounded
          class="ma-3"
          color="primary"
          >SEND CLIENT FORM</v-btn
        >
      </template>
      <v-card
        class="ma-auto pa-2"
        flat
        filled
        style="
          border-radius: 26px;
          border: 1px solid #18CAE6;
          max-width: 600px;
        "
      >
        <v-card-title>
          <span>
            CLIENT
            <span class="red--text">FORM</span>
          </span>
        </v-card-title>
        <v-form class="ma-2 pa-2" @submit.prevent="sendClientForm" ref="form">
          <div>
            <v-card
              style="max-width: 500px"
              outlined
              tile
              rounded
              class="ma-auto"
              dense
            >
              <v-checkbox
                label="CREATE A CUSTOM CLIENT FORM"
                v-model="customForm"
              ></v-checkbox>
              <div>OR</div>
              <v-checkbox
                label="SELECT FROM A LIST OF EXISTING FORMS"
                v-model="existingForm"
              ></v-checkbox>
              <v-expand-transition>
                <div v-if="existingForm">
                  <!-- <v-autocomplete
                    clearable
                    :items="formList"
                    outlined
                    label="SELECT FORM"
                    v-model="formDef.preMadeForm"
                  ></v-autocomplete>-->
                  <v-autocomplete
                    clearable
                    :items="formList"
                    outlined
                    label="SELECT FORM"
                    v-model="preMadeForm"
                    autocomplete="off"
                    multiple
                    color="#2E5473"
                    dense
                    filled
                  ></v-autocomplete>
                </div>
              </v-expand-transition>

              <v-expand-transition>
                <div v-if="customForm">
                  <v-radio-group label="Select Input Type" v-model="inputType">
                    <v-radio label="Text Field" value="textField"></v-radio>
                    <v-radio label="Date Field" value="dateField"></v-radio>
                  </v-radio-group>
                </div>
              </v-expand-transition>

              <v-checkbox
                label="I WOULD LIKE TO EMAIL THIS FORM"
                v-model="sendEmail"
              ></v-checkbox>
              <!-- <v-card-actions>
                <v-btn
                  rounded
                  outlined
                  color="green"
                  type="submit"
                  :disabled="!validSendForm"
                  >SUBMIT</v-btn
                >
                <v-progress-circular
                  class="text-center ma-auto"
                  indeterminate
                  size="64"
                  v-if="overlay"
                ></v-progress-circular>
                <v-btn rounded outlined @click="cancelDialog"
                  >CANCEL</v-btn
                ></v-card-actions
              > -->

              <div class="ma-3" v-for="(email, toindex) in to" :key="email">
                TO: {{ email }}
                <v-btn
                  v-if="sendEmail"
                  small
                  rounded
                  outlined
                  color="red"
                  @click="removeToEmail(toindex)"
                  >remove email</v-btn
                >
              </div>
              <v-expand-transition>
                <div v-if="sendEmail">
                  <v-combobox
                    v-model="toField"
                    @update:search-input="addToEmail"
                    label="ADD OR SELECT A DIRECT RECIPIENT"
                    color="#2E5473"
                    dense
                    filled
                    style="max-width: 500px"
                    class="ma-auto"
                    clearable
                    outlined
                    :items="sendToOptions"
                    @keyup.enter="addTo"
                    hide-selected
                    return-object
                    disable-lookup
                    validate-on-blur
                    autocomplete="off"
                  ></v-combobox>
                  <v-btn
                    v-if="sendEmail"
                    small
                    rounded
                    outlined
                    color="green"
                    @click="addTo"
                    class="ma-2"
                    >add email</v-btn
                  >
                  <v-spacer></v-spacer>
                </div>
              </v-expand-transition>
              <div class="ma-3" v-for="(email, ccindex) in cc" :key="email">
                <div>CC: {{ email }}</div>
                <v-btn
                  v-if="sendEmail"
                  small
                  rounded
                  outlined
                  color="red"
                  @click="removeCCEmail(ccindex)"
                  >remove email</v-btn
                >
              </div>
              <v-expand-transition>
                <div v-if="sendEmail">
                  <v-combobox
                    v-model="ccField"
                    @update:search-input="addCCEmail"
                    label="ADD OR SELECT CC RECIPIENTS"
                    color="#2E5473"
                    dense
                    filled
                    style="max-width: 500px"
                    class="ma-auto"
                    clearable
                    outlined
                    :items="sendToOptions"
                    @keyup.enter="addCC"
                    hide-selected
                    return-object
                    disable-lookup
                    validate-on-blur
                    autocomplete="off"
                  ></v-combobox>
                  <v-btn
                    v-if="sendEmail"
                    small
                    rounded
                    outlined
                    color="green"
                    @click="addCC"
                    class="ma-2"
                    >add email</v-btn
                  >
                  <v-spacer></v-spacer>
                </div>
              </v-expand-transition>
              <div class="ma-3" v-for="(email, bccindex) in bcc" :key="email">
                <div>BCC: {{ email }}</div>
                <v-btn
                  small
                  rounded
                  outlined
                  color="red"
                  @click="removeBCCEmail(bccindex)"
                  v-if="sendEmail"
                  >remove email</v-btn
                >
              </div>
              <v-expand-transition>
                <div v-if="sendEmail">
                  <v-combobox
                    v-model="bccField"
                    @update:search-input="addBCCEmail"
                    label="ADD OR SELECT BCC RECIPIENTS"
                    color="#2E5473"
                    dense
                    filled
                    style="max-width: 500px"
                    class="ma-auto"
                    clearable
                    outlined
                    :items="sendToOptions"
                    @keyup.enter="addBCC"
                    hide-selected
                    return-object
                    disable-lookup
                    validate-on-blur
                    autocomplete="off"
                  ></v-combobox>
                  <v-btn
                    v-if="sendEmail"
                    small
                    rounded
                    outlined
                    color="green"
                    @click="addBCC"
                    class="ma-2"
                    >add email</v-btn
                  >
                  <v-spacer></v-spacer>
                </div>
              </v-expand-transition>
            </v-card>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded outlined text color="red" @click="cancelDialog"
              >CANCEL</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn @click="resetType" rounded text outlined>reset</v-btn>
            <v-spacer></v-spacer>
            <!-- <v-btn rounded color="black" :disabled="!formIsValid" dark type="submit">SUBMIT</v-btn> -->
            <v-btn
              rounded
              outlined
              type="submit"
              color="green"
              :disabled="!validSendForm"
              >SUBMIT</v-btn
            >
            <!-- <v-btn rounded dark outlined type="submit" @click="getIndex">get index</v-btn> -->
            <v-progress-circular
              class="text-center ma-auto"
              indeterminate
              size="64"
              v-if="overlay"
            ></v-progress-circular>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
/**
 *
 *
 * this component allows the user to send a pre-determined form to their client
 * via link.
 *
 * this component also allows the user to create a set of questions to send their client.
 *
 * this component allows the link to be sent to any number of emails, with CC and BCC recipients as well
 *
 * this component calls a cloud function with the data and th ecloud function sends the email.
 *
 * THIS COMPONENT STILL NEEDS A LOT OF WORK
 *
 *
 */

import * as firebase from "firebase";
import slugify from "slugify";
import moment from "moment";

export default {
  props: ["plaintiff", "matter", "user"],
  data() {
    return {
      dialog: false,
      filter: [],
      formRoute: null,
      customForm: false,
      existingForm: true,
      checkBox1: false,
      checkBox2: false,
      checkBox3: false,
      checkBox4: false,
      checkBox5: false,
      checkBox6: false,
      formDef: {
        questions: [],
        preMadeForm: null
      },
      preMadeForm: [],
      // tempEmail: null,
      toField: null,
      ccField: null,
      bccField: null,
      to: [],
      cc: [],
      bcc: [],
      tempToEmail: null,
      tempCCEmail: null,
      tempBCCEmail: null,
      inputType: null,
      formList: [
        "WOOLSEY FIRE CASES, JCCP 5000 - PERSONAL CLAIMS",
        "WOOLSEY FIRE CASES, JCCP 5000 - PROPERTY CLAIMS",
        "CREEK FIRE CASES, JCCP 4965 - PERSONAL CLAIMS",
        "CREEK FIRE CASES, JCCP 4965 - PROPERTY CLAIMS",
        "FORM INTERROGATORIES - GENERAL (CALIFORNIA)"
      ],
      sendEmail: true,
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      },
      overlay: false
    };
  },
  computed: {
    validSendForm() {
      if (this.preMadeForm.length || this.formDef.questions > 0) {
        if (this.to.length || this.cc.length || this.bcc.length) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    stepCount() {
      return this.formDef.questions.length;
    },
    // emailList() {
    //   return
    // }
    sendToOptions() {
      let array = [
        this.plaintiff.email,
        this.user.email,
        this.matter.creatorID
      ];
      this.matter.sharedWith.forEach(email => {
        array.push(email);
      });
      return array;
    }
  },
  watch: {
    preMadeForm(val) {
      if (val === "FORM INTERROGATORIES - GENERAL (CALIFORNIA)") {
        console.log(val);
        console.log("fire something here");
        this.formDef.preMadeForm = val;
        console.log(this.formDef);
      }
    },
    filter(questions) {
      // console.log(val);
      if (questions) {
        questions.forEach(val => {
          if (val === "massTort") {
            this.checkBox1 = true;
            this.checkBox2 = true;
            this.checkBox3 = true;
            this.checkBox4 = true;
            this.checkBox5 = true;
          }
          if (val === "autoAccident") {
            this.checkBox1 = true;
            this.checkBox2 = true;
            this.checkBox4 = true;
            this.checkBox5 = true;
          }
        });
      }
    },
    customForm(val) {
      if (val === true) {
        this.existingForm = false;
      }
    },
    existingForm(val) {
      if (val === true) {
        this.customForm = false;
      }
      if (val === false) {
        this.preMadeForm = [];
        // this.preMadeForm = null;
      }
    }
  },
  methods: {
    addTo() {
      if (
        !this.cc.includes(this.tempToEmail) &&
        !this.to.includes(this.tempToEmail) &&
        !this.bcc.includes(this.tempToEmail)
      ) {
        this.to.push(this.tempToEmail);
        this.tempToEmail = null;
        this.toField = "";
        // let el = document.getElementById("toField");
        // console.log(el.value);
        // el.value = "";
        //clear the input
        // console.log(this.$refs);
        // this.$refs.toField.reset();

        // console.log(this.$refs);
      } else {
        alert(`this email is already in your 'To' list:${this.tempToEmail}`);
      }
    },
    addToEmail(currentValue) {
      this.tempToEmail = currentValue;
    },
    addCC() {
      if (
        !this.cc.includes(this.tempCCEmail) &&
        !this.to.includes(this.tempCCEmail) &&
        !this.bcc.includes(this.tempCCEmail)
      ) {
        this.cc.push(this.tempCCEmail);
        this.tempCCEmail = null;
        //clear the input
        this.ccField = "";
      } else {
        alert(`this email is already in your 'CC' list:${this.tempCCEmail}`);
      }
    },
    addCCEmail(currentValue) {
      this.tempCCEmail = currentValue;
    },
    addBCC() {
      if (
        !this.cc.includes(this.tempBCCEmail) &&
        !this.to.includes(this.tempBCCEmail) &&
        !this.bcc.includes(this.tempBCCEmail)
      ) {
        this.bcc.push(this.tempBCCEmail);
        this.tempBCCEmail = null;
        //clear the input
        this.bccField = "";
      } else {
        alert(`this email is already in your 'CC' list:${this.tempBCCEmail}`);
      }
    },
    addBCCEmail(currentValue) {
      this.tempBCCEmail = currentValue;
    },
    removeToEmail(toindex) {
      this.to.splice(toindex, 1);
      // this.tempEmail = null
    },
    removeCCEmail(ccindex) {
      this.cc.splice(ccindex, 1);
      // this.tempEmail = null
    },
    removeBCCEmail(bccindex) {
      this.bcc.splice(bccindex, 1);
      // this.tempEmail = null
    },
    // getIndex() {
    //   // let index = this.matter.plaintiffs.indexOf(this.plaintiff);
    //   // console.log(index);
    //   let plaintiffList = this.matter.plaintiffs;
    //   let index = plaintiffList.indexOf(this.plaintiff);
    //   console.log(index);
    //   let newFormDef = {
    //     id: `123`,
    //     link: `https://www.taplaw.com/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/`,
    //     path: `/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/`
    //   };
    //   plaintiffList[index].formList.push(newFormDef);
    //   console.log(plaintiffList);
    //   console.log(this.matter.plaintiffs);
    // },
    resetType() {
      this.$refs.form.reset();
      this.filter = [];
      this.formDef.questions = [];
      this.existingForm = false;
      this.customForm = false;
    },
    saveFormResponse(res, id, formSlug, form) {
      // console.log("response from getForm", res);
      console.log("form from saveFormResponses fired from sendForm", form);
      firebase
        .firestore()
        // .collection("firms")
        // .doc(this.user.firmSlug)
        .collection("matters")
        .doc(this.matter.matterSlug)
        .collection("clients")
        .doc(this.plaintiff.partySlug)
        .collection("formList")
        .doc(id)
        .update({
          instructions: res.data.instructions,
          windowSteps: res.data.windowSteps,
          documentCategories: res.data.documentCategories,
          responses: res.data.responses,
          id: id,
          link: `https://www.taplaw.com/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`,
          path: `/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`
        })
        // })
        .then(() => {
          //get the index of the plaintiff form matter.plaintiffs
          let plaintiffList = this.matter.plaintiffs;
          let index = plaintiffList.indexOf(this.plaintiff);
          console.log(index);
          let newFormDef = {
            id: id,
            link: `https://www.taplaw.com/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`,
            path: `/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`
          };
          if (plaintiffList[index].formList) {
            plaintiffList[index].formList.push(newFormDef);
          } else {
            plaintiffList[index].formList = [];
            plaintiffList[index].formList.push(newFormDef);
          }
          // plaintiffList[index].formList.push(newFormDef)

          firebase
            .firestore()

            .collection("matters")
            .doc(this.matter.matterSlug)

            .update({
              plaintiffs: plaintiffList
            });
        })
        .then(() => {
          console.log("edited plaintiff list");

          // send email to client with link
          if (this.sendEmail) {
            // let to,string;
            let matter = {
              caseName: this.matter.caseName
            };
            // firebase
            //   .app()
            //   .functions()
            //   .useFunctionsEmulator("http://localhost:5001");

            const sendTestEmail = firebase
              .functions()
              .httpsCallable("sendTestEmail");
            console.log("sending email");
            sendTestEmail({
              link: `https://www.taplaw.com/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`,
              additionalEmail: `${this.tempEmail}`,
              plaintiff: this.plaintiff,
              matter: matter,
              user: this.user,
              formName: form,
              to: this.to,
              cc: this.cc,
              bcc: this.bcc
            })
              .then(() => {
                this.overlay = false;
                this.$refs.form.reset();
                this.filter = null;
                this.formDef.questions = [];
                this.tempEmail = null;
                this.dialog = false;

                this.tempToEmail = null;
                this.tempCCEmail = null;
                this.tempBCCEmail = null;
                this.to = [];
                this.cc = [];
                this.bcc = [];
              })
              .catch(e => {
                console.log(e);
              });
          }
          // this.overlay = false;
          // this.$refs.form.reset();
          // this.filter = null;
          // this.formDef.questions = [];
          // this.tempEmail = null;
          // this.dialog = false;

          // this.tempToEmail = null;
          // this.tempCCEmail = null;
          // this.tempBCCEmail = null;
        })
        .catch(err => {
          console.log(err);
          this.overlay = false;
        });
    },
    async sendClientForm() {
      // let formSlug = slugify(this.formDef.preMadeForm, {
      //   replacement: "-",
      //   remove: /[$*_+~.()'"!\-:@,]/g,
      //   lower: true
      // });
      console.log("this.premade forms", this.preMadeForm);
      this.preMadeForm.forEach(form => {
        this.overlay = true;
        console.log(form);
        let formSlug = slugify(`${form}`, {
          replacement: "-",
          remove: /[$*_+~.()'"!\-:@,]/g,
          lower: true
        });
        // let index;
        // if (this.plaintiff.formList) {
        //   index = this.plaintiff.formList.length;
        // } else {
        //   index = 0;
        // }
        if (this.checkBox1 == true) {
          if (
            !this.formDef.questions.includes("generalBackgroundInformation")
          ) {
            this.formDef.questions.push("generalBackgroundInformation");
          }
        }
        if (this.checkBox2 == true) {
          if (!this.formDef.questions.includes("insurance")) {
            this.formDef.questions.push("insurance");
          }
        }
        if (this.checkBox3 == true) {
          if (!this.formDef.questions.includes("realProperty")) {
            this.formDef.questions.push("realProperty");
          }
        }
        if (this.checkBox4 == true) {
          if (!this.formDef.questions.includes("personalInjury")) {
            this.formDef.questions.push("personalInjury");
          }
        }
        if (this.checkBox5 == true) {
          if (!this.formDef.questions.includes("lossOfIncome")) {
            this.formDef.questions.push("lossOfIncome");
          }
        }
        if (this.checkBox6 == true) {
          if (!this.formDef.questions.includes("otherDamages")) {
            this.formDef.questions.push("otherDamages");
          }
        }
        //if checkbox = false
        if (this.checkBox1 == false) {
          if (this.formDef.questions.includes("generalBackgroundInformation")) {
            let index = this.formDef.questions.indexOf(
              "generalBackgroundInformation"
            );
            this.formDef.questions.splice(index, 1);
          }
        }
        if (this.checkBox2 == false) {
          if (this.formDef.questions.includes("insurance")) {
            let index = this.formDef.questions.indexOf("insurance");
            this.formDef.questions.splice(index, 1);
          }
        }
        if (this.checkBox3 == false) {
          if (this.formDef.questions.includes("realProperty")) {
            let index = this.formDef.questions.indexOf("realProperty");
            this.formDef.questions.splice(index, 1);
          }
        }
        if (this.checkBox4 == false) {
          if (this.formDef.questions.includes("personalInjury")) {
            let index = this.formDef.questions.indexOf("personalInjury");
            this.formDef.questions.splice(index, 1);
          }
        }
        if (this.checkBox5 == false) {
          if (this.formDef.questions.includes("lossOfIncome")) {
            let index = this.formDef.questions.indexOf("lossOfIncome");
            this.formDef.questions.splice(index, 1);
          }
        }
        if (this.checkBox6 == false) {
          if (this.formDef.questions.includes("otherDamages")) {
            let index = this.formDef.questions.indexOf("otherDamages");
            this.formDef.questions.splice(index, 1);
          }
        }
        if (form !== null && form !== undefined) {
          let formDef = {
            name: form,
            windowSteps: 0,
            // link: this.formRoute,
            dateSent: moment().format("MMMM Do YYYY, h:mm:ss a"),
            instructions: null,
            responses: null,
            responseDate: null,
            responseEdited: null,
            user: this.user.email,
            formSlug: formSlug,
            documentCategories: [],
            partySlug: this.plaintiff.partySlug,
            partyName: this.plaintiff.fullName,
            matterSlug: this.matter.matterSlug,
            partyType: this.plaintiff.type

            //there should be a casetypes array
            //caseTypes: this.matter.caseTypes
            // path: `/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${index}`
          };

          // let path = `/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${index}`;
          firebase
            .firestore()
            // .collection("firms")
            // .doc(this.user.firmSlug)
            .collection("matters")
            .doc(this.matter.matterSlug)
            .collection("clients")
            .doc(this.plaintiff.partySlug)
            .collection("formList")
            .add(formDef)
            .then(docRef => {
              console.log("updated client formList with doc, ", docRef.id);
              let id = docRef.id;
              //get the list of questions form the cloud function
              if (form === "CREEK FIRE CASES, JCCP 4965 - PERSONAL CLAIMS") {
                //  RUN FUNCTION IN EMULATOR
                // firebase
                //   .app()
                //   .functions()
                //   .useFunctionsEmulator("http://localhost:5001");
                const getFireClaimQuestions = firebase
                  .functions()
                  .httpsCallable("getFireClaimQuestions");
                getFireClaimQuestions({
                  name: form,
                  type: this.plaintiff.type,
                  firmSlug: this.user.firmSlug,
                  title: `${this.matter.specialTitle}`
                })
                  .then(res => {
                    this.saveFormResponse(res, id, formSlug, form);
                  })
                  .catch(e => {
                    console.log(e);
                  });
              } else if (
                form === "CREEK FIRE CASES, JCCP 4965 - PROPERTY CLAIMS"
              ) {
                // firebase
                //   .app()
                //   .functions()
                //   .useFunctionsEmulator("http://localhost:5001");
                const getFirePropertyClaimQuestions = firebase
                  .functions()
                  .httpsCallable("getFirePropertyClaimQuestions");
                getFirePropertyClaimQuestions({
                  name: form,
                  type: this.plaintiff.type,
                  firmSlug: this.user.firmSlug,
                  title: `${this.matter.specialTitle}`,
                  lossDate: `December 5, 2017`
                })
                  .then(res => {
                    this.saveFormResponse(res, id, formSlug, form);
                  })
                  .catch(e => {
                    console.log(e);
                  });
              } else {
                const getForm = firebase.functions().httpsCallable("getForm");
                // firebase
                //   .app()
                //   .functions()
                //   .useFunctionsEmulator("http://localhost:5001");
                getForm({
                  name: form,
                  type: this.plaintiff.type,
                  firmSlug: this.user.firmSlug
                  //there should be a casetypes array
                  //caseTypes: this.matter.caseTypes
                }).then(res => {
                  //set the response to the formDef blank - (later add a snapshot to the form -- forEach ...onsnapshot)
                  console.log("response from getForm", res);
                  firebase
                    .firestore()
                    // .collection("firms")
                    // .doc(this.user.firmSlug)
                    .collection("matters")
                    .doc(this.matter.matterSlug)
                    .collection("clients")
                    .doc(this.plaintiff.partySlug)
                    .collection("formList")
                    .doc(id)
                    .update({
                      instructions: res.data.instructions,
                      windowSteps: res.data.windowSteps,
                      documentCategories: res.data.documentCategories,
                      responses: res.data.responses,
                      id: id,
                      link: `https://www.taplaw.com/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`,
                      path: `/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`
                    })
                    // })
                    .then(() => {
                      //get the index of the plaintiff form matter.plaintiffs
                      let plaintiffList = this.matter.plaintiffs;
                      let index = plaintiffList.indexOf(this.plaintiff);
                      console.log(index);
                      let newFormDef = {
                        id: id,
                        link: `https://www.taplaw.com/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`,
                        path: `/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`
                      };
                      if (plaintiffList[index].formList) {
                        plaintiffList[index].formList.push(newFormDef);
                      } else {
                        plaintiffList[index].formList = [];
                        plaintiffList[index].formList.push(newFormDef);
                      }
                      // plaintiffList[index].formList.push(newFormDef)

                      firebase
                        .firestore()

                        .collection("matters")
                        .doc(this.matter.matterSlug)

                        .update({
                          plaintiffs: plaintiffList
                        });
                    })
                    .then(() => {
                      console.log("edited plaintiff list");

                      // send email to client with link
                      if (this.sendEmail) {
                        // let to,string;
                        let matter = {
                          caseName: this.matter.caseName
                        };
                        // firebase
                        //   .app()
                        //   .functions()
                        //   .useFunctionsEmulator("http://localhost:5001");

                        const sendTestEmail = firebase
                          .functions()
                          .httpsCallable("sendTestEmail");
                        sendTestEmail({
                          link: `https://www.taplaw.com/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`,
                          additionalEmail: `${this.tempEmail}`,
                          plaintiff: this.plaintiff,
                          matter: matter,
                          user: this.user,
                          formName: form,
                          to: this.to,
                          cc: this.cc,
                          bcc: this.bcc
                        })
                          .then(() => {
                            this.overlay = false;
                            this.$refs.form.reset();
                            this.filter = null;
                            this.formDef.questions = [];
                            this.tempEmail = null;
                            this.dialog = false;

                            this.tempToEmail = null;
                            this.tempCCEmail = null;
                            this.tempBCCEmail = null;
                            this.to = [];
                            this.cc = [];
                            this.bcc = [];
                          })
                          .catch(e => {
                            console.log(e);
                          });
                      }
                      // this.overlay = false;
                      // this.$refs.form.reset();
                      // this.filter = null;
                      // this.formDef.questions = [];
                      // this.tempEmail = null;
                      // this.dialog = false;

                      // this.tempToEmail = null;
                      // this.tempCCEmail = null;
                      // this.tempBCCEmail = null;
                    })
                    .catch(err => {
                      console.log(err);
                      this.overlay = false;
                    });
                });
              }
            })
            .catch(err => {
              console.log(err);
              this.overlay = false;
            });
          // })
          // .catch(err => {
          //   console.log(err);
          // });
        }
      });
      // this.overlay = true;
      // console.log(this.preMadeForm);

      // let formSlug = slugify(`${this.preMadeForm}`, {
      //   replacement: "-",
      //   remove: /[$*_+~.()'"!\-:@,]/g,
      //   lower: true
      // });
      // let index;
      // if (this.plaintiff.formList) {
      //   index = this.plaintiff.formList.length;
      // } else {
      //   index = 0;
      // }

      // this.formRoute = `https://www.taplaw.com/firm/${this.user.firmSlug}/matter/${this.matter.matterSlug}/client/${this.plaintiff.partySlug}`;
      // this.formRoute = `https://www.taplaw.com/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${index}`;
      // console.log("from viewPlaintiff");
      // console.log("matter", this.matter);
      // console.log("user", this.user);
      // console.log("plaintiff", this.plaintiff);
      // console.log("formRoute", this.formRoute);
      //opens a dialog that allows the user to select which questions they want answered

      //if checkbox = true
      // if (this.checkBox1 == true) {
      //   if (!this.formDef.questions.includes("generalBackgroundInformation")) {
      //     this.formDef.questions.push("generalBackgroundInformation");
      //   }
      // }
      // if (this.checkBox2 == true) {
      //   if (!this.formDef.questions.includes("insurance")) {
      //     this.formDef.questions.push("insurance");
      //   }
      // }
      // if (this.checkBox3 == true) {
      //   if (!this.formDef.questions.includes("realProperty")) {
      //     this.formDef.questions.push("realProperty");
      //   }
      // }
      // if (this.checkBox4 == true) {
      //   if (!this.formDef.questions.includes("personalInjury")) {
      //     this.formDef.questions.push("personalInjury");
      //   }
      // }
      // if (this.checkBox5 == true) {
      //   if (!this.formDef.questions.includes("lossOfIncome")) {
      //     this.formDef.questions.push("lossOfIncome");
      //   }
      // }
      // if (this.checkBox6 == true) {
      //   if (!this.formDef.questions.includes("otherDamages")) {
      //     this.formDef.questions.push("otherDamages");
      //   }
      // }
      // //if checkbox = false
      // if (this.checkBox1 == false) {
      //   if (this.formDef.questions.includes("generalBackgroundInformation")) {
      //     let index = this.formDef.questions.indexOf(
      //       "generalBackgroundInformation"
      //     );
      //     this.formDef.questions.splice(index, 1);
      //   }
      // }
      // if (this.checkBox2 == false) {
      //   if (this.formDef.questions.includes("insurance")) {
      //     let index = this.formDef.questions.indexOf("insurance");
      //     this.formDef.questions.splice(index, 1);
      //   }
      // }
      // if (this.checkBox3 == false) {
      //   if (this.formDef.questions.includes("realProperty")) {
      //     let index = this.formDef.questions.indexOf("realProperty");
      //     this.formDef.questions.splice(index, 1);
      //   }
      // }
      // if (this.checkBox4 == false) {
      //   if (this.formDef.questions.includes("personalInjury")) {
      //     let index = this.formDef.questions.indexOf("personalInjury");
      //     this.formDef.questions.splice(index, 1);
      //   }
      // }
      // if (this.checkBox5 == false) {
      //   if (this.formDef.questions.includes("lossOfIncome")) {
      //     let index = this.formDef.questions.indexOf("lossOfIncome");
      //     this.formDef.questions.splice(index, 1);
      //   }
      // }
      // if (this.checkBox6 == false) {
      //   if (this.formDef.questions.includes("otherDamages")) {
      //     let index = this.formDef.questions.indexOf("otherDamages");
      //     this.formDef.questions.splice(index, 1);
      //   }
      // }

      // trying something different with this list of forms:
      // if (this.preMadeForm !== null && this.preMadeForm !== undefined) {
      //   let formDef = {
      //     name: this.preMadeForm,
      //     windowSteps: 0,
      //     // link: this.formRoute,
      //     dateSent: moment().format("MMMM Do YYYY, h:mm:ss a"),
      //     instructions: null,
      //     responses: null,
      //     responseDate: null,
      //     responseEdited: null,
      //     user: this.user.email,
      //     formSlug: formSlug,
      //     documentCategories: [],
      //     partySlug: this.plaintiff.partySlug,
      //     partyName: this.plaintiff.fullName,
      //     matterSlug: this.matter.matterSlug,
      //     partyType: this.plaintiff.type

      //     //there should be a casetypes array
      //     //caseTypes: this.matter.caseTypes
      //     // path: `/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${index}`
      //   };

      //   // let path = `/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${index}`;
      //   firebase
      //     .firestore()
      //     // .collection("firms")
      //     // .doc(this.user.firmSlug)
      //     .collection("matters")
      //     .doc(this.matter.matterSlug)
      //     .collection("clients")
      //     .doc(this.plaintiff.partySlug)
      //     .collection("formList")
      //     .add(formDef)
      //     .then(docRef => {
      //       console.log("updated client formList with doc, ", docRef.id);
      //       let id = docRef.id;
      //       //get the list of questions form the cloud function
      //       if (
      //         this.preMadeForm ===
      //         "CREEK FIRE CASES, JCCP 4965 - PERSONAL CLAIMS"
      //       ) {
      //         //  RUN FUNCTION IN EMULATOR
      //         // firebase
      //         //   .app()
      //         //   .functions()
      //         //   .useFunctionsEmulator("http://localhost:5001");
      //         const getFireClaimQuestions = firebase
      //           .functions()
      //           .httpsCallable("getFireClaimQuestions");
      //         getFireClaimQuestions({
      //           name: this.preMadeForm,
      //           type: this.plaintiff.type,
      //           firmSlug: this.user.firmSlug,
      //           title: `${this.matter.specialTitle}`
      //         })
      //           .then(res => {
      //             this.saveFormResponse(res, id, formSlug);
      //           })
      //           .catch(e => {
      //             console.log(e);
      //           });
      //       } else if (
      //         this.preMadeForm ===
      //         "CREEK FIRE CASES, JCCP 4965 - PROPERTY CLAIMS"
      //       ) {
      //         // firebase
      //         //   .app()
      //         //   .functions()
      //         //   .useFunctionsEmulator("http://localhost:5001");
      //         const getFirePropertyClaimQuestions = firebase
      //           .functions()
      //           .httpsCallable("getFirePropertyClaimQuestions");
      //         getFirePropertyClaimQuestions({
      //           name: this.preMadeForm,
      //           type: this.plaintiff.type,
      //           firmSlug: this.user.firmSlug,
      //           title: `${this.matter.specialTitle}`,
      //           lossDate: `December 5, 2017`
      //         })
      //           .then(res => {
      //             this.saveFormResponse(res, id, formSlug);
      //           })
      //           .catch(e => {
      //             console.log(e);
      //           });
      //       } else {
      //         const getForm = firebase.functions().httpsCallable("getForm");
      //         getForm({
      //           name: this.preMadeForm,
      //           type: this.plaintiff.type,
      //           firmSlug: this.user.firmSlug
      //           //there should be a casetypes array
      //           //caseTypes: this.matter.caseTypes
      //         }).then(res => {
      //           //set the response to the formDef blank - (later add a snapshot to the form -- forEach ...onsnapshot)
      //           console.log("response from getForm", res);
      //           firebase
      //             .firestore()
      //             // .collection("firms")
      //             // .doc(this.user.firmSlug)
      //             .collection("matters")
      //             .doc(this.matter.matterSlug)
      //             .collection("clients")
      //             .doc(this.plaintiff.partySlug)
      //             .collection("formList")
      //             .doc(id)
      //             .update({
      //               instructions: res.data.instructions,
      //               windowSteps: res.data.windowSteps,
      //               documentCategories: res.data.documentCategories,
      //               responses: res.data.responses,
      //               id: id,
      //               link: `https://www.taplaw.com/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`,
      //               path: `/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`
      //             })
      //             // })
      //             .then(() => {
      //               //get the index of the plaintiff form matter.plaintiffs
      //               let plaintiffList = this.matter.plaintiffs;
      //               let index = plaintiffList.indexOf(this.plaintiff);
      //               console.log(index);
      //               let newFormDef = {
      //                 id: id,
      //                 link: `https://www.taplaw.com/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`,
      //                 path: `/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`
      //               };
      //               if (plaintiffList[index].formList) {
      //                 plaintiffList[index].formList.push(newFormDef);
      //               } else {
      //                 plaintiffList[index].formList = [];
      //                 plaintiffList[index].formList.push(newFormDef);
      //               }
      //               // plaintiffList[index].formList.push(newFormDef)

      //               firebase
      //                 .firestore()

      //                 .collection("matters")
      //                 .doc(this.matter.matterSlug)

      //                 .update({
      //                   plaintiffs: plaintiffList
      //                 });
      //             })
      //             .then(() => {
      //               console.log("edited plaintiff list");

      //               // send email to client with link
      //               if (this.sendEmail) {
      //                 // let to,string;
      //                 let matter = {
      //                   caseName: this.matter.caseName
      //                 };
      //                 const sendTestEmail = firebase
      //                   .functions()
      //                   .httpsCallable("sendTestEmail");
      //                 sendTestEmail({
      //                   link: `https://www.taplaw.com/client/${this.user.firmSlug}/${this.matter.matterSlug}/${this.plaintiff.partySlug}/${formSlug}/${id}`,
      //                   additionalEmail: `${this.tempEmail}`,
      //                   plaintiff: this.plaintiff,
      //                   matter: matter,
      //                   user: this.user,
      //                   formName: this.preMadeForm,
      //                   to: this.to,
      //                   cc: this.cc,
      //                   bcc: this.bcc
      //                 })
      //                   .then(() => {
      //                     this.overlay = false;
      //                     this.$refs.form.reset();
      //                     this.filter = null;
      //                     this.formDef.questions = [];
      //                     this.tempEmail = null;
      //                     this.dialog = false;

      //                     this.tempToEmail = null;
      //                     this.tempCCEmail = null;
      //                     this.tempBCCEmail = null;
      //                     this.to = [];
      //                     this.cc = [];
      //                     this.bcc = [];
      //                   })
      //                   .catch(e => {
      //                     console.log(e);
      //                   });
      //               }
      //               this.overlay = false;
      //               this.$refs.form.reset();
      //               this.filter = null;
      //               this.formDef.questions = [];
      //               this.tempEmail = null;
      //               this.dialog = false;

      //               this.tempToEmail = null;
      //               this.tempCCEmail = null;
      //               this.tempBCCEmail = null;
      //             })
      //             .catch(err => {
      //               console.log(err);
      //               this.overlay = false;
      //             });
      //         });
      //       }
      //     })
      //     .catch(err => {
      //       console.log(err);
      //       this.overlay = false;
      //     });
      //   // })
      //   // .catch(err => {
      //   //   console.log(err);
      //   // });
      // }
    },
    cancelDialog() {
      this.$refs.form.reset();
      this.filter = null;
      this.formDef.questions = [];
      this.dialog = false;
      this.to = [];
      this.cc = [];
      this.bcc = [];
      this.tempToEmail = null;
      this.tempCCEmail = null;
      this.tempBCCEmail = null;
    }
  }
};
</script>
